import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
export default function NoObjectionCertificate({ branchData, student }) {
  const printRef = useRef();
//
    

   // parentName: student?.fatherName || "",
   // address: student?.homeAddress || "",
   // duration: getCourseDuration(
   //   student?.selectedCourse || "",
   //   student?.academicYear || ""
   // ),

   //  admissionNo: student?.studentId || "",
  const [formData, setFormData] = useState({
    name:   [student?.firstName, student?.middleName, student?.lastName]
        .filter(Boolean)
        .join(" ") || "",
     course: student?.selectedCourse || "",
    examCourse: "BSc",
    examMonth: "DECEMBER",
    examYear: "2025",
    feesCompletion: "",
   date: new Date().toLocaleDateString("en-GB"),

    place: "Bangalore",
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

 const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>NO OBJECTION CERTIFICATE</title>
          <style>
            body {
              font-family: "Times New Roman", serif;
              padding: 40px;
            }

           .header {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}

.logo {
  display: block;
  width: 80px;
  margin: 0 auto 5px auto;
}

.title-main,
.title-sub {
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.title-main {
  font-size: 20px;
}

.title-sub {
  font-size: 16px;
  margin-bottom: 20px;
}

            .field-row {
              margin: 18px 0;
              font-size: 15px;
            }

            .label {
              display: inline-block;
              width: 200px;
              font-weight: bold;
            }

            .line {
              display: inline-block;
              border-bottom: 1px dotted #000;
              width: 60%;
              height: 18px;
            }

            .footer {
              margin-top: 60px;
            }

            .left {
              float: left;
            }

            .right {
              float: right;
              font-weight: bold;
            }

            .clear {
              clear: both;
            }

          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Container className="mt-4">

      {/* PRINT AREA */}
      <div ref={printRef}>
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
  <img src={branchData?.logoUrl} style={{ width: "80px" }} />
</div>
        <div className="title-main">
          REHOBOTH INSTITUTE OF NURSING
        </div>

        <div className="title-sub">
          NO OBJECTION CERTIFICATE FOR{" "}
          {formData.examCourse} {formData.examMonth} {formData.examYear}
        </div>

        <div className="title-sub">EXAMINATION</div>

        <div className="field-row">
          <span className="label">NAME</span> :
          <span className="line">{formData.name}</span>
        </div>

        <div className="field-row">
          <span className="label">COURSE</span> :
          <span className="line">{formData.course}</span>
        </div>

        <div className="field-row">
          <span className="label">FEES COMPLETION</span> :
          <span className="line">{formData.feesCompletion}</span>
        </div>

        <div className="footer">
          <div className="left">
            <div>Date : {formData.date}</div>
            <div>Place : {formData.place}</div>
          </div>

          <div className="right">ADMIN</div>
          <div className="clear"></div>
        </div>

      </div>

      {/* FORM */}
      <Form className="mt-4">

        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Name"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </Col>
          <Col>
            <Form.Control
              placeholder="Course"
              value={formData.course}
              onChange={(e) => handleChange("course", e.target.value)}
            />
          </Col>
        </Row>

        {/* 🔥 Editable Exam Title */}
        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Exam Course (BSc / GNM)"
              value={formData.examCourse}
              onChange={(e) =>
                handleChange("examCourse", e.target.value)
              }
            />
          </Col>
          <Col>
            <Form.Control
              placeholder="Month (DECEMBER)"
              value={formData.examMonth}
              onChange={(e) =>
                handleChange("examMonth", e.target.value.toUpperCase())
              }
            />
          </Col>
          <Col>
            <Form.Control
              placeholder="Year"
              value={formData.examYear}
              onChange={(e) =>
                handleChange("examYear", e.target.value)
              }
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Fees Completion"
              value={formData.feesCompletion}
              onChange={(e) =>
                handleChange("feesCompletion", e.target.value)
              }
            />
          </Col>
          <Col>
         <Form.Control
  type="date"
  onChange={(e) => {
    const value = e.target.value;

    if (value) {
      const formatted = new Date(value).toLocaleDateString("en-GB");
      handleChange("date", formatted);
    }
  }}
/>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Place"
              onChange={(e) => handleChange("place", e.target.value)}
            />
          </Col>
        </Row>

        <Button onClick={handlePrint} className="mt-3">
          Print
        </Button>

      </Form>
    </Container>
  );
}